import React, { useContext, useEffect, useState, useRef } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import "./navbar.css";
import NavContext from '../../contexts/NavContext';

import Logo from '../../assets/images/logo.svg';
import Shop from '../../assets/icons/shop-card.svg';
import Search from '../../assets/icons/search.svg';
import Profile from '../../assets/icons/profile.svg';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { getCategories, getSettings } from '../../utils/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Form, Modal } from 'react-bootstrap';
import { Toast } from 'primereact/toast';
import { Badge } from 'primereact/badge';
import { useCart } from '../../contexts/CartContext';
// mobile icons
import Bag from '../../assets/icons/menu/bag-happy.svg';
import Grid from '../../assets/icons/menu/grid.svg';
import Home from '../../assets/icons/menu/home.svg';
import List from '../../assets/icons/menu/list.svg';
import ArrowDown from '../../assets/icons/arrow-down.svg';
import Magicpen from '../../assets/icons/menu/magicpen.svg';
import Basket from '../basket/basket';
import Loader from '../../components/loader/dotloader'
import LoaderBtn from '../../components/loader/loader'
import debounce from 'lodash.debounce'; // نصب با npm i lodash.debounce
import { Menu } from 'primereact/menu';
import { classNames } from 'primereact/utils';
import { Avatar } from 'primereact/avatar';

//active
import ActiveGrid from '../../assets/icons/menu/active/category.svg';
import ActiveBasket from '../../assets/icons/menu/active/basket.svg';
import ActiveMagicpen from '../../assets/icons/menu/active/magicpen.svg';
import ActiveHome from '../../assets/icons/menu/active/home.svg';
import ActiveList from '../../assets/icons/menu/active/list.svg';
import { useSelector } from 'react-redux';
import useToastNotification from '../../hooks/useToastNotification';
import CardIcon from '../../assets/icons/panel/card.svg'
import Logout from '../../assets/icons/panel/logout.svg'
import Personal from '../../assets/icons/panel/personal.svg'
import Coin from '../../assets/icons/panel/coin.svg'
const NavbarComponent = () => {
  const toast = useRef(null);
  const [categoryList, setCategoryList] = useState([]);
  const customerData = useSelector(state => {
    let data = state.customerData;
    if (typeof data === 'string') {
      return JSON.parse(data)
    }
    else {
      return data
    }
  });
  const [pageLoading, setPageLoading] = useState(false)
  const [loader, setLoaderBtn] = useState(false)
  const [searchText, setSearchText] = useState('')
  const { setNav } = useContext(NavContext);
  const [validated, setValidated] = useState(false);
  const location = useLocation();
  const searchBox = useRef(null);
  const menuLeft = useRef(null);

  const [totalItems, setTotalItems] = useState('');
  const itemRenderer = (item) => (
    <div className='p-menuitem-content d-flex align-items-center py-2' style={{ gap: '2em' }} onClick={item.command}>
      <img src={item.icon} alt="" />
      <h6 className='mb-0 text-sm	'>{item.label}</h6>
    </div>
  );
  let items = [
    {
      label: 'اطلاعات کاربری',
      icon: Personal,
      command: (event) => {navigate('/panel?section=info')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'کارت های من',
      icon: CardIcon,
      command: (event) => {navigate('/panel?section=cards')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'شارژ کارت',
      icon: Coin,
      command: (event) => {navigate('/panel?section=charge')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'خروج',
      icon: Logout,
      command: () => logout(),
      template: itemRenderer
    }
  ];
  const [logoutModalShow, setLogoutModalShow] = React.useState(false);
  const closeLogoutModal = () => {
    setLogoutModalShow(false);
  };
  const logout = () => {
    setLogoutModalShow(true);
  };
  const logoutFromAccount = () => {
    localStorage.removeItem('userData')
    sessionStorage.removeItem('cartItems')
    localStorage.removeItem('token')
    window.location.href = '/'
  };

  const { cartItems } = useCart();
  const navigate = useNavigate(); // useNavigate for navigation without refresh

  const changeNav = (name) => {
    setNav(name);
  };

  const getSettingsfun = async () => {
    try {
      setPageLoading(true)

      let setting = await getSettings()
      if (setting.data.isSuccess) {

        localStorage.setItem('settings', JSON.stringify(setting.data.data))
        setPageLoading(false)
      }

    } catch (error) {
      setPageLoading(false)

    }
  }
  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      // behavior: "smooth", // برای حرکت نرم اسکرول
    });
  }, [location.pathname]); // هر بار که مسیر تغییر می‌کند، این کد اجرا می‌شود.
  const { showError, showSuccess } = useToastNotification();

  const getCategory = async () => {
    setPageLoading(true)
    try {
      let res = await getCategories();
      setCategoryList(res.data.data);
      sessionStorage.setItem('categories', JSON.stringify(res.data.data));
      setPageLoading(false)
    } catch (error) {
      setPageLoading(false)
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    getCategory();
    getSettingsfun()
    let clientId = localStorage.getItem('clientId'); // بررسی کلاینت آی‌دی در localStorage

    // if (!clientId) {
    //   clientId = crypto.randomUUID(); // تولید مقدار جدید اگر وجود نداشته باشد
    //   localStorage.setItem('clientId', clientId); // ذخیره در localStorage
    // }
     if (!clientId) {
          // Check if the browser supports crypto.randomUUID
          if (typeof crypto !== 'undefined' && crypto.randomUUID) {
              clientId = crypto.randomUUID();
            } else {
              // Fallback for older browsers or non-secure contexts
              clientId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
              });
            }
        
        localStorage.setItem('clientId', clientId);
      }

  }, []);
  useEffect(() => {
    if (cartItems || cartItems === 0) { // بررسی دقیق مقدار 0
      localStorage.setItem('totalItems', cartItems); // ذخیره در localStorage
      setTotalItems(cartItems); // تعداد محصولات
    } else {
      const savedItems = localStorage.getItem('totalItems');
      setTotalItems(savedItems ? parseInt(savedItems, 10) : 0); // مقدار پیش‌فرض
    }
  }, [cartItems]);

  const getProductByCategory = (item) => {
    navigate(`/categories?id=${item.id}&title=${item.text}`); // Use navigate instead of window.location.href
  };
  const serachProduct = async (e) => {
    e.preventDefault();
    setLoaderBtn(true)
    if (searchText == '') {
      return

    }
    const form = e.currentTarget;
    if (form.checkValidity() === true) {
      navigate(`/categories?id=0&title=${searchText}`);

    }
    setValidated(true);
  }
  // تابع جستجو
  const searchProduct = (query) => {
    if (query.trim().length > 0) {
      navigate(`/categories?id=0&title=${query}`);
    }
  };

  // تابع debounced که جستجو را در ضریبی از 4 کاراکتر انجام می‌دهد
  const handleSearchInput = debounce((query) => {
    if (query.length % 4 === 0 && query.length > 0) {
      searchProduct(query); // جستجو را فراخوانی می‌کنیم
    }
  }, 500); // تاخیر 500 میلی‌ثانیه

  // تغییرات در جعبه جستجو
  const onSearchTextChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    handleSearchInput(value); // ارسال به debounced
  };
  const activePagesPaths = ["/pageList", "/login", "/panel", "/rules", "/faq", "/contact-us", "/about-us", "/activation"];

  const forbiddenBuyBasketShownRoutes = ['/payment', '/shopping-cart'];
  useEffect(() => {
    console.log(location);
  }, []);
  return (
    <>
      <Toast ref={toast} />
      <Modal
        show={logoutModalShow}
        onHide={() => setLogoutModalShow(false)}
        centered
      >
        <Modal.Body className='!p-5'>
          <div className="flex gap-1 border-b-[#668CFF] border-b-[1px] pb-3">
            <img src={require('../../assets/icons/danger.svg').default} alt="" />
            <div className="font-bold text-blue">خروج</div>
          </div>
          <div className='font-bold mt-4'>از حساب کاربری خارج می‌شوید؟</div>
          <div className="flex gap-2 mt-4">
            <button className='btn btn-outline-primary !border-1 !border-blue flex-1' onClick={closeLogoutModal}>انصراف</button>
            <button className='btn btn-primary flex-[2]' onClick={() => logoutFromAccount()}>خروج از حساب کاربری</button>
          </div>
        </Modal.Body>
      </Modal>
      {pageLoading && <Loader isLoading={pageLoading} />}
      <Navbar expand='lg' className='web-navbar'>
        <div className='navbar-menu container mt-4 d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center justify-content-start '>
            <img src={Logo} alt="Logo" onClick={() => { window.location.href = "/" }} style={{ marginLeft: '2em', width: '50px' }} />
            <Navbar.Collapse id="basic-navbar-nav">

              <Nav activeKey={location.pathname}>
                <Nav.Item >
                  <Nav.Link as={Link} to="/" active={location.pathname === "/"}>خانه</Nav.Link>
                </Nav.Item>
                <Nav.Item >
                  <NavDropdown active={location.pathname === "/categories"} style={{ marginTop: '2.5px' }} title={<div className='d-flex align-items-end'><h6 className='nav-link p-0 m-0'>دسته بندی ها</h6>
                    <div style={{ width: '20px', marginRight: '5px' }}>
                      <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.2797 5.9668L8.93306 10.3135C8.41973 10.8268 7.57973 10.8268 7.06639 10.3135L2.71973 5.9668" stroke="#494C50" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>

                  </div>} id="basic-nav-dropdown">
                    <div className="row">
                    <div  className="col-4" onClick={() => navigate('/categories')}>
                          <NavDropdown.Item>همه محصولات</NavDropdown.Item>
                        </div>

                      {categoryList.length > 0 && categoryList.map((item) => (
                        <div key={item.id} className="col-4" onClick={() => getProductByCategory(item)}>
                          <NavDropdown.Item>{item.text}</NavDropdown.Item>
                        </div>
                      ))}
                    </div>
                  </NavDropdown>
                </Nav.Item> 
                <Nav.Item >
                  <Nav.Link as={Link} to="/design" active={location.pathname === "/design"}>طرح دلخواه</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/activation" active={location.pathname === "/activation"}>شارژ و فعالسازی</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/balance" active={location.pathname === "/balance"}>استعلام کادونا</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/catalog" active={location.pathname === "/catalog"}>کاتالوگ</Nav.Link>
                </Nav.Item>
              </Nav>
            </Navbar.Collapse>
          </div>
          <div className='d-flex align-items-center justify-content-start gap-1'>
            {!forbiddenBuyBasketShownRoutes.includes(location.pathname) &&
              <Basket />
            }
            <button onClick={(e) => searchBox.current.toggle(e)} className='border-[1px] d-flex align-items-center justify-content-center py-2 border-blue border-solid rounded-lg p-2 hover:bg-[#0033cc24]  animation' style={{ width: '44px', height: '44px' }}>
              <img src={Search} alt="Search" />
            </button>
            <button className='btn btn-primary d-flex align-items-center py-2 ' style={{ height: '44px',minWidth: '163px' }} onClick={(event) => {
              if (customerData == null) { navigate('/login') } else if (location.pathname != '/panel') {
                menuLeft.current.toggle(event)
              }
            }}>
              <img src={Profile} style={{ marginLeft: '3px' }} alt="Profile" />
              {customerData == null ? 'ورود' : customerData.fullName}
              {location.pathname !== '/panel' && customerData != null && (
                <div style={{marginRight: '0.5em'}}> 
                   <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.2797 5.9668L8.93306 10.3135C8.41973 10.8268 7.57973 10.8268 7.06639 10.3135L2.71973 5.9668" stroke="#fff" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg> 
                </div>
              

              )}
            </button>
          </div>
        </div>
        <Menu model={items} popup ref={menuLeft} id="popup_menu_navbar" width={164}/>

      </Navbar >
      <OverlayPanel ref={searchBox}>
        <Form noValidate validated={validated} onSubmit={(e) => serachProduct(e)}>
          <Form.Group controlId="text">
            <div className='d-flex align-items-center input-icon'>
              <Form.Control
                required
                placeholder='جستجو کنید...'
                value={searchText}
                onChange={onSearchTextChange}
              />
              <button className='btn  text-center' type='submit'> <img src={Search} alt="Search" /></button>
            </div>
          </Form.Group>
        </Form>
      </OverlayPanel>
      {/* Mobile Navbar */}
      <div className='mobile-navbar'>
        <Link to="/design">
          <img src={location.pathname === "/design" ? ActiveMagicpen : Magicpen} alt="Magicpen"/>
          <span>طرح دلخواه</span>
        </Link>
        <Link to="/categories">
          <img src={location.pathname === "/categories" ? ActiveGrid : Grid} alt="Categories"/>
          <span>دسته بندی</span>
        </Link>
        <Link to="/">
        <img src={location.pathname === "/" ? ActiveHome : Home} alt="Home" />
        <span >  صفحه اصلی</span>
        </Link>
        <Link to="/shopping-cart">
          <div style={{position: 'relative'}}>
            <img src={location.pathname === "/shopping-cart" || location.pathname === "/peyment" ? ActiveBasket : Bag}
                 alt="Bag"/>
            {totalItems > 0 && <Badge className='number' value={totalItems} severity="danger" size="normal"
                                      style={{position: 'absolute', top: '-1em', right: '-1em'}}></Badge>}
            <span >سبد خرید</span>
          </div>
        </Link>
        <Link to="/pageList">
          <img src={activePagesPaths.includes(location.pathname) ? ActiveList : List} alt="List"/>
          <span>منو</span>
        </Link>
      </div>

    </>
  );
}

export default NavbarComponent;
